export const projectDetails = [
  {
    id: 1,
    slug: 'nha-pho-bo-phi-binh-thanh',
    type: 'SỬA - BÁN',
    tag: 'Nhà Phố',
    title: 'Nhà Phố Xuống Cấp – Bình Thạnh',
    location: 'Bình Thạnh, TP.HCM',
    area: '90 m²',
    duration: '2 tháng',
    completedDate: 'Tháng 2, 2026',
    result: '+20% Giá Trị',
    soldIn: '52 ngày',
    beforePrice: '9 tỷ',
    afterPrice: '10.8 tỷ',
    investCost: '540 triệu',
    profit: '1.26 tỷ',
    roi: '333%',
    situation: 'Nhà phố mặt tiền hẻm lớn 90m², bỏ trống gần 1 năm, mặt tiền và nội thất xuống cấp nghiêm trọng. Rao bán nhiều kênh mà không ai hỏi thăm dù giá kỳ vọng của chủ nhà chưa phải là cao.',
    coverImage: 'https://public.readdy.ai/ai/img_res/2444002f5db392927b4eacdf919bc4be.jpg',
    beforeImages: [
      'https://readdy.ai/api/search-image?query=old%20neglected%20Vietnamese%20townhouse%20narrow%20facade%20peeling%20paint%20rusted%20gate%20overgrown%20entrance%20before%20renovation%20inner%20city%2C%20documentary%20street%20photo%20natural%20light&width=700&height=500&seq=d1b1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=old%20Vietnamese%20townhouse%20interior%20before%20renovation%20dark%20dated%20furniture%20worn%20floor%20tiles%20cluttered%20living%20room%202004%20style&width=700&height=500&seq=d1b2&orientation=landscape',
    ],
    afterImages: [
      'https://readdy.ai/api/search-image?query=renovated%20Vietnamese%20townhouse%20minimal%20white%20facade%20clean%20modern%20gate%20premium%20street%20entrance%20after%20renovation%2C%20professional%20bright%20real%20estate%20exterior%20photo&width=700&height=500&seq=d1a1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=modern%20townhouse%20interior%20after%20renovation%20open%20concept%20white%20walls%20light%20wood%20floor%20minimalist%20staging%20furniture%20bright%20natural%20light&width=700&height=500&seq=d1a2&orientation=landscape',
    ],
    timeline: [
      { week: 'Tuần 1–2', phase: 'Bắt mạch & Lên phương án', desc: 'Phân tích thị trường mua trong bán kính 500m, xác định phân khúc mục tiêu, lập phương án cải tạo ROI tối ưu' },
      { week: 'Tuần 3–5', phase: 'Cải tạo mặt tiền & Kết cấu', desc: 'Xử lý thấm, sơn mới toàn bộ mặt tiền, thay cổng sắt, cải tạo hàng rào, ốp đá chân tường' },
      { week: 'Tuần 5–7', phase: 'Nội thất & Hoàn thiện', desc: 'Thay sàn gỗ công nghiệp toàn bộ 3 tầng, sơn nội thất trắng neutral, nâng cấp bếp và 2 phòng tắm' },
      { week: 'Tuần 8', phase: 'Staging & Ảnh bán hàng', desc: 'Bố trí nội thất staging Japandi tối giản 5 phòng, chụp ảnh góc rộng chuyên nghiệp, đưa lên thị trường với listing mới' },
    ],
    improvements: [
      'Cải tạo toàn bộ mặt tiền, sơn trắng neutral hiện đại',
      'Thay cổng sắt mới, ốp đá chân tường ngoại thất',
      'Thay toàn bộ sàn gỗ công nghiệp tông sáng 3 tầng',
      'Nâng cấp bếp: tủ bếp mới + bếp từ + máy hút mùi',
      'Cải tạo 2 phòng tắm, thay toàn bộ thiết bị vệ sinh',
      'Staging nội thất 5 phòng phong cách Japandi tối giản',
    ],
    testimonial: 'Nhà tôi rao gần 1 năm không ai đặt cọc. UPLIVING cải tạo 2 tháng, 52 ngày sau khi ra listing mới là chốt xong. Bán được 10.8 tỷ — vượt kỳ vọng ban đầu của tôi.',
    testimonialAuthor: 'Anh Nguyễn Quốc Hùng, Chủ tài sản Bình Thạnh',
  },
  {
    id: 2,
    slug: 'dat-trong-xay-chdv-go-vap',
    type: 'XÂY - THUÊ',
    tag: 'Nhà Nát',
    title: 'Nhà Nát 2 Tầng → CHDV 5 Tầng – Quận 3',
    location: 'Quận 3, TP.HCM',
    area: '53 m²',
    duration: '9 tháng',
    completedDate: 'Tháng 1, 2026',
    result: '20.5% ROI/năm',
    rentedIn: '7 ngày',
    buildCost: '4.5 tỷ (xây dựng)',
    totalInvest: '4.5 tỷ',
    monthlyRent: '77 triệu/tháng',
    annualROI: '20.5%',
    roi: '20.5%/năm',
    situation: 'Nhà nát 2 tầng 53m² đất tại số 8 Cư Xá Trần Quang Diệu, Quận 3, cho shop mini thuê tạm được 12 triệu/tháng. Chủ biết tiềm năng nhưng không dám xây vì sợ rủi ro — không biết mô hình nào sinh lời, lo xây xong không cho thuê được.',
    coverImage: 'https://storage.readdy-site.link/project_files/8054470c-40ef-49ec-8cd3-eaeff47b62d7/81a8b16c-be98-475a-9070-881bc2c5c91c_b6af90efd83a6064392b.jpg?v=4e10803c2ef5f176c556e694fc0ac731',
    beforeImages: [
      'https://storage.readdy-site.link/project_files/8054470c-40ef-49ec-8cd3-eaeff47b62d7/638ebf07-f9c3-4c99-989b-d63e5092240c_f8f5e55ac83949671028.jpg?v=bbafd26bfe4706396acd9a5b8be11e97',
    ],
    afterImages: [
      'https://storage.readdy-site.link/project_files/8054470c-40ef-49ec-8cd3-eaeff47b62d7/81a8b16c-be98-475a-9070-881bc2c5c91c_b6af90efd83a6064392b.jpg?v=4e10803c2ef5f176c556e694fc0ac731',
      'https://storage.readdy-site.link/project_files/8054470c-40ef-49ec-8cd3-eaeff47b62d7/bbcc1ddf-1fe1-4eb8-8a3b-f4fbb755560c_z5421030541010_c68ae9c431e3da42fff0aad252befe35.jpg?v=470f7c20ef32b770c35b3cded572526e',
      'https://storage.readdy-site.link/project_files/8054470c-40ef-49ec-8cd3-eaeff47b62d7/bbcc1ddf-1fe1-4eb8-8a3b-f4fbb755560c_z5421030558707_40f201973ac08c7de4441117f4774420.jpg?v=470f7c20ef32b770c35b3cded572526e',
    ],
    timeline: [
      { week: 'Tháng 1–2', phase: 'Khảo sát & Thiết kế mô hình', desc: 'Phân tích thị trường cho thuê trong bán kính 1km Quận 3, xác định phân khúc CHDV mini cao cấp, thiết kế tối ưu 11 căn trên 5 tầng đúng phép.' },
      { week: 'Tháng 2–3', phase: 'Phá dỡ & Cấp phép xây dựng', desc: 'Phá dỡ nhà nát 2 tầng cũ, làm hồ sơ xin phép xây dựng 5 tầng, đổ móng cọc, thi công phần thô tầng 1–2' },
      { week: 'Tháng 3–7', phase: 'Xây thô 5 tầng', desc: 'Xây tường, đổ sàn toàn bộ 5 tầng, lắp mái, lắp khung cửa sổ và cửa đi, hoàn thiện phần thô' },
      { week: 'Tháng 7–9', phase: 'Hoàn thiện, Nội thất & Vận hành', desc: 'Trát sơn, lát sàn, lắp đặt điện nước, nội thất đồng bộ 11 căn đúng phép, thiết lập quy trình vận hành UPLIVING, marketing khai trương (chưa làm thêm 4 phòng giai đoạn 2, ~400 triệu nữa).' },
    ],
    improvements: [
      '11 căn studio 12-15m², thiết kế tối ưu từng m² trên 5 tầng',
      'Full nội thất: giường, tủ, bàn làm việc, bếp mini, lò viba, tủ lạnh, máy giặt, máy nước NL',
      'Máy lạnh inverter, máy nước nóng riêng từng căn',
      'Mỗi căn có cửa sổ nhìn ra hẻm/ban công, đón sáng tự nhiên',
      'Camera an ninh, khóa thẻ từ từng căn, thang bộ thoát hiểm',
      'Phân chia điện nước riêng biệt, minh bạch chi phí từng căn',
      'Vận hành bởi UPLIVING: tuyển khách, thu tiền, bảo trì',
    ],
    testimonial: 'Nhà nát cho thuê shop mini 12 triệu/tháng, tôi cứ nghĩ vậy là ổn. UPLIVING đề xuất xây CHDV 5 tầng 11 căn — giờ thu 77 triệu/tháng ổn định hơn 6 lần so với trước. Khai trương 7 ngày là kín phòng.',
    testimonialAuthor: 'Anh Nguyễn Hoàng Phúc, Chủ nhà Quận 3',
  },
  {
    id: 3,
    slug: 'villa-cu-cho-thue-kem-thu-duc',
    type: 'VẬN HÀNH',
    tag: 'Villa Cũ',
    title: 'Villa Cũ Cho Thuê Kém → 3x Dòng Tiền',
    location: 'TP. Thủ Đức, TP.HCM',
    area: '280 m²',
    duration: '55 ngày',
    completedDate: 'Tháng 1, 2026',
    result: '+247% Dòng Tiền',
    rentedIn: '8 ngày',
    beforeMonthly: '15 triệu/tháng',
    afterMonthly: '52 triệu/tháng',
    investCost: '520 triệu',
    roi: '3.5x dòng tiền',
    situation: 'Villa 280m² cho thuê nguyên căn 15 triệu/tháng, tỷ lệ lấp đầy thấp, thường trống 2-3 tháng/năm. Chủ muốn tăng dòng tiền nhưng không biết mô hình nào phù hợp.',
    coverImage: 'https://readdy.ai/api/search-image?query=renovated%20premium%20villa%20exterior%20modern%20minimal%20design%20lush%20garden%20pool%20terrace%20well-lit%20co-living%20premium%20rental%20Thu%20Duc%20Vietnam%2C%20architectural%20photography%20bright%20day&width=1200&height=600&seq=d3cover&orientation=landscape',
    beforeImages: [
      'https://readdy.ai/api/search-image?query=old%20suburban%20villa%20garden%20unkempt%20worn%20exterior%20paint%20peeling%20dated%20architecture%20low-occupancy%20rental%20property%20Thu%20Duc%20Vietnam%20before%20renovation%2C%20natural%20light%20photo&width=700&height=500&seq=d3b1&orientation=landscape',
    ],
    afterImages: [
      'https://readdy.ai/api/search-image?query=renovated%20premium%20villa%20exterior%20modern%20minimal%20garden%20pool%20terrace%20well-lit%20premium%20co-living%20rental%2C%20architectural%20photography%20bright&width=700&height=500&seq=d3a1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=co-living%20house%20interior%20modern%20common%20area%20lounge%20bright%20minimal%20furniture%20natural%20light%20premium%20shared%20living%20space%20Vietnam&width=700&height=500&seq=d3a2&orientation=landscape',
    ],
    timeline: [
      { week: 'Tuần 1–2', phase: 'Bắt mạch & Thiết kế mô hình', desc: 'Phân tích mô hình cho thuê hiện tại vs. tiềm năng co-living. Lập phương án chia phòng tối ưu 7 phòng' },
      { week: 'Tuần 3–5', phase: 'Cải tạo phân phòng', desc: 'Xây vách ngăn, cải tạo 7 phòng độc lập, nâng cấp 3 phòng tắm chung, khu vực bếp và sinh hoạt chung' },
      { week: 'Tuần 6–7', phase: 'Nội thất & Vận hành', desc: 'Lắp đặt nội thất đồng bộ, thiết lập quy trình vận hành UPLIVING, marketing tuyển khách' },
    ],
    improvements: [
      'Đổi mô hình từ cho thuê nguyên căn → co-living premium 7 phòng',
      'Cải tạo tạo 7 phòng ngủ độc lập, có khóa riêng',
      'Khu vực chung: bếp, phòng khách, sân vườn được cải tạo cao cấp',
      'Nội thất 7 phòng đồng bộ theo phong cách tối giản',
      'Vận hành bởi UPLIVING: tuyển khách, thu tiền, bảo trì',
      'Báo cáo dòng tiền minh bạch theo tháng',
    ],
    testimonial: 'Villa tôi cho thuê 15 triệu/tháng mà còn hay trống. Sau khi UPLIVING đổi mô hình co-living, thu nhập tăng lên 52 triệu — và tôi không cần làm gì cả.',
    testimonialAuthor: 'Anh Trần Văn Minh, Chủ Villa',
  },
  {
    id: 4,
    slug: 'nha-pho-kho-ban-tan-binh',
    type: 'SỬA - BÁN',
    tag: 'Nhà Phố',
    title: 'Nhà Phố Khó Bán 14 Tháng – Tân Bình',
    location: 'Tân Bình, TP.HCM',
    area: '130 m²',
    duration: '3 tháng',
    completedDate: 'Tháng 3, 2026',
    result: '+26% & Bán 68 Ngày',
    soldIn: '68 ngày',
    beforePrice: '11 tỷ (rao 14 tháng)',
    afterPrice: '13.9 tỷ',
    investCost: '880 triệu',
    profit: '2.02 tỷ',
    roi: '330%',
    situation: 'Nhà phố 130m² gần ngã tư lớn, rao bán 14 tháng qua 3 đơn vị môi giới khác nhau. Không có vấn đề pháp lý — nhưng không gian cũ kỹ, bố trí thiếu logic, không tạo được cảm xúc cho người xem nhà.',
    coverImage: 'https://readdy.ai/api/search-image?query=bright%20modern%20Vietnamese%20townhouse%20after%20renovation%20open%20concept%20living%20minimalist%20white%20walls%20light%20wood%20floor%20staging%20premium%20interior%20Tan%20Binh%20real%20estate%20photo&width=1200&height=600&seq=d4cover&orientation=landscape',
    beforeImages: [
      'https://readdy.ai/api/search-image?query=dated%20Vietnamese%20shophouse%20interior%20dark%20cluttered%20old%20furniture%20for%20sale%20difficult%20to%20sell%20before%20renovation%20dim%20lighting%20interior%20real%20estate%20photo&width=700&height=500&seq=d4b1&orientation=landscape',
    ],
    afterImages: [
      'https://readdy.ai/api/search-image?query=bright%20modern%20Vietnamese%20shophouse%20interior%20after%20renovation%20open%20concept%20white%20walls%20staging%20furniture%20minimalist%20natural%20light%20premium%20real%20estate%20photo&width=700&height=500&seq=d4a1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=renovated%20townhouse%20kitchen%20after%20modern%20minimalist%20white%20cabinets%20marble%20countertop%20natural%20light%20premium%20Vietnam%20interior&width=700&height=500&seq=d4a2&orientation=landscape',
    ],
    timeline: [
      { week: 'Tuần 1–2', phase: 'Phân tích & Định vị lại', desc: 'Phân tích tại sao chưa bán được, xác định profile khách mua thực sự, lên phương án cải tạo nhắm đúng đối tượng' },
      { week: 'Tuần 3–6', phase: 'Cải tạo nhắm target', desc: 'Sơn toàn bộ trắng/neutral, thay sàn gỗ công nghiệp, cải tạo bếp mở và phòng tắm master, tối giản hóa không gian' },
      { week: 'Tuần 7–9', phase: 'Hoàn thiện & Nội thất', desc: 'Cải tạo phòng ngủ master, nâng cấp hệ thống điện và chiếu sáng, lắp đặt nội thất đồng bộ' },
      { week: 'Tuần 10–12', phase: 'Staging & Marketing mới', desc: 'Bố trí staging đúng phong cách khách target, chụp ảnh chuyên nghiệp + tour 360°, đưa ra thị trường với định vị hoàn toàn mới' },
    ],
    improvements: [
      'Sơn lại toàn bộ nội thất màu trắng/kem neutral',
      'Thay sàn toàn bộ sang sàn gỗ công nghiệp tông sáng',
      'Cải tạo bếp mở: đảo bếp granite, tủ bếp mới, backsplash',
      'Cải tạo phòng tắm master cao cấp, thay thiết bị vệ sinh',
      'Staging tối giản theo profile khách mua mục tiêu',
      'Chụp ảnh chuyên nghiệp + tour 360° cho listing mới',
      'Chiến lược marketing + listing hoàn toàn mới',
    ],
    testimonial: '14 tháng, 3 đơn vị môi giới mà không ai đặt cọc. UPLIVING cải tạo 3 tháng, 68 ngày sau khi ra listing mới là có người chuyển cọc. Giá 13.9 tỷ — cao hơn tôi dám kỳ vọng.',
    testimonialAuthor: 'Chị Phạm Ngọc Bích, Chủ tài sản Tân Bình',
  },
  {
    id: 5,
    slug: 'building-mini-cho-thue-quan-3',
    type: 'XÂY - THUÊ',
    tag: 'Building Mini',
    title: 'Nền Đất → Building Mini 6 Tầng – Q.3',
    location: 'Quận 3, TP.HCM',
    area: '320 m²',
    duration: '150 ngày',
    completedDate: 'Tháng 11, 2025',
    result: '15.2% ROI/năm',
    rentedIn: '10 ngày',
    landCost: 'Đã có đất',
    buildCost: '4.8 tỷ (xây dựng)',
    totalInvest: '4.8 tỷ',
    monthlyRent: '95 triệu/tháng',
    annualROI: '15.2%',
    roi: '15.2%/năm',
    situation: 'Nền đất 320m² mặt đường Quận 3 bỏ trống gần 2 năm. Chủ đất muốn xây nhưng không biết mô hình nào sẽ sinh lời, sợ xây xong không cho thuê được.',
    coverImage: 'https://readdy.ai/api/search-image?query=premium%20modern%206%20floor%20mini%20building%20serviced%20apartments%20boutique%20hotel%20teal%20white%20facade%20smart%20glass%20central%20Ho%20Chi%20Minh%20City%20Quan%203%2C%20professional%20architectural%20photography%20bright&width=1200&height=600&seq=d5cover&orientation=landscape',
    beforeImages: [
      'https://readdy.ai/api/search-image?query=urban%20land%20lot%20empty%20plot%20street%20corner%20prime%20location%20Quan%203%20Ho%20Chi%20Minh%20City%20before%20construction%2C%20daylight%20street%20photograph%20documentary%20realistic&width=700&height=500&seq=d5b1&orientation=landscape',
    ],
    afterImages: [
      'https://readdy.ai/api/search-image?query=premium%20modern%206%20floor%20mini%20building%20serviced%20apartments%20teal%20white%20facade%20smart%20glass%20central%20Ho%20Chi%20Minh%20City%2C%20professional%20architectural%20photography&width=700&height=500&seq=d5a1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=premium%20serviced%20apartment%20interior%20modern%20minimalist%20bedroom%20hotel%20quality%20white%20linen%20city%20view%20window%20Quan%203%20HCMC&width=700&height=500&seq=d5a2&orientation=landscape',
    ],
    timeline: [
      { week: 'Tháng 1', phase: 'Nghiên cứu thị trường', desc: 'Phân tích nhu cầu cho thuê khu Quận 3, xác định phân khúc boutique serviced apartment, lập business case' },
      { week: 'Tháng 2', phase: 'Thiết kế & Cấp phép', desc: 'Thiết kế kiến trúc tối ưu 10 căn hộ / 6 tầng, làm hồ sơ xin phép xây dựng' },
      { week: 'Tháng 3–6', phase: 'Thi công toàn bộ', desc: 'Xây dựng phần thô, hoàn thiện, lắp đặt thang máy, hệ thống PCCC, điện 3 pha' },
      { week: 'Tháng 7', phase: 'Nội thất & Vận hành', desc: 'Lắp đặt nội thất 10 căn đồng bộ boutique, thiết lập vận hành, marketing khai trương' },
    ],
    improvements: [
      '10 căn hộ dịch vụ 28–45m², thiết kế boutique premium',
      'Thang máy, lobby, hành lang đầy đủ tiêu chuẩn',
      'Full nội thất cao cấp theo phong cách tối giản đương đại',
      'Hệ thống smarthome: khóa app, điều hòa, đèn tự động',
      'Camera an ninh, bộ đàm bảo vệ 24/7',
      'Vận hành toàn bộ bởi UPLIVING, báo cáo online theo tháng',
    ],
    testimonial: 'Tôi có đất Quận 3 mà không dám xây vì sợ không cho thuê được. UPLIVING phân tích thị trường rất kỹ và cam kết mô hình. Khai trương 10 ngày đã kín 10/10 căn.',
    testimonialAuthor: 'Anh Vũ Đình Phong, Chủ đất Quận 3',
  },
  {
    id: 6,
    slug: 'villa-cu-ban-duoc-gia-thu-duc',
    type: 'SỬA - BÁN',
    tag: 'Nhà Phố',
    title: 'Nhà Phố 5 Tầng – Bán Thành Công Sau 4 Tháng',
    location: 'Nội Đô, TP.HCM',
    area: '160 m²',
    duration: '75 ngày',
    completedDate: 'Tháng 2, 2026',
    result: '+20% Giá Trị',
    soldIn: '2,5 + 1,5\u00a0tháng',
    beforePrice: '33 tỷ',
    afterPrice: '39.5 tỷ',
    investCost: '1.8 tỷ',
    profit: '4.7 tỷ',
    roi: '361%',
    situation: 'Nhà phố 5 tầng 160m² xây từ năm 2018, kiến trúc lỗi thời, nội thất xuống cấp, hệ thống điện nước cũ. Rao bán gần 2 năm ở mức 33 tỷ — có người xem nhưng không chốt vì hệ thống điện nước cũ kĩ, thấm dột khắp nơi, phòng tối bí và công năng bất tiện, người mua không cảm nhận được giá trị tương xứng với mức giá.',
    coverImage: 'https://public.readdy.ai/ai/img_res/edited_7478fa21bb7ae373d8510c3d42c15cd8_ed5f5167.jpg',
    beforeImages: [
      'https://public.readdy.ai/ai/img_res/edited_c4c6ba9e207c6c46917f29d61cb1b65c_097578ca.jpg',
      'https://readdy.ai/api/search-image?query=old%20Vietnamese%20townhouse%205%20floor%20interior%20before%20renovation%20dark%20dated%20furniture%20worn%20floor%20tiles%20cluttered%20living%20room%20dim%20lighting%20inner%20city%202018%20style&width=700&height=500&seq=d6b2new&orientation=landscape',
    ],
    afterImages: [
      'https://public.readdy.ai/ai/img_res/edited_7478fa21bb7ae373d8510c3d42c15cd8_ed5f5167.jpg',
      'https://readdy.ai/api/search-image?query=modern%20renovated%20Vietnamese%20townhouse%205%20floor%20interior%20after%20renovation%20open%20concept%20white%20walls%20marble%20floor%20natural%20light%20staging%20furniture%20minimalist%20premium%20inner%20city%20HCMC&width=700&height=500&seq=d6a2new&orientation=landscape',
    ],
    timeline: [
      { week: 'Tuần 1–2', phase: 'Bắt mạch & Phương án thiết kế', desc: 'Khảo sát kỹ thuật toàn bộ, xác định profile khách mua target (gia đình thu nhập cao, doanh nhân), lên phương án cải tạo tối ưu ROI' },
      { week: 'Tuần 3–6', phase: 'Cải tạo mặt ngoài & Kết cấu', desc: 'Làm mới mặt tiền hiện đại tối giản, thay cổng sắt mới, ốp đá ngoại thất, chống thấm toàn bộ 5 tầng, thay toàn bộ hệ thống điện nước' },
      { week: 'Tuần 7–9', phase: 'Hoàn thiện nội thất', desc: 'Cải tạo toàn bộ 5 tầng: thay sàn gỗ công nghiệp, sơn trắng neutral, nâng cấp bếp mở, cải tạo 3 phòng tắm, hệ thống điện chiếu sáng mới' },
      { week: 'Tuần 10–11', phase: 'Staging & Marketing nhắm đúng phân khúc', desc: 'Staging nội thất cao cấp phong cách tối giản đương đại, chụp ảnh chuyên nghiệp, tour 360°, chiến dịch marketing nhắm khách mua phân khúc cao' },
    ],
    improvements: [
      'Cải tạo toàn bộ mặt tiền 5 tầng từ lỗi thời sang hiện đại tối giản',
      'Thay cổng sắt, cửa chính, ốp đá chân tường ngoại thất mới',
      'Thay mới toàn bộ hệ thống điện nước, xử lý thấm dột triệt để',
      'Thay toàn bộ sàn gỗ công nghiệp tông sáng 5 tầng',
      'Cải tạo bếp mở: đảo bếp marble, tủ bếp mới, backsplash cao cấp',
      'Cải tạo 3 phòng tắm theo chuẩn khách sạn 4 sao',
      'Staging nội thất tối giản đương đại 5 phòng chủ chốt',
    ],
    testimonial: 'Nhà rao gần 2 năm, ai xem cũng lắc đầu vì điện nước cũ và thấm dột. UPLIVING cải tạo lại toàn bộ, 1,5 tháng sau khi ra listing mới là chốt xong 39.5 tỷ. Lời thêm gần 5 tỷ so với khi tôi tự bán.',
    testimonialAuthor: 'Gia đình ông Nguyễn Thanh Bình, Nội Đô TP.HCM',
  },
];
